import Marquee from "react-fast-marquee";
import { BRAND } from "@/data";

const WORDS = [
  "Empowering your productivity",
  "Elevating your business",
  "White-glove support",
  "Worldwide · Remote",
];

export default function EditorialMarquee() {
  return (
    <div
      data-testid="marquee"
      className="py-6 border-y"
      style={{
        backgroundColor: "var(--mocha-brown)",
        borderColor: "var(--mocha-deep)",
      }}
    >
      <Marquee speed={42} gradient={false} autoFill>
        {WORDS.map((w) => (
          <span key={w} className="flex items-center">
            <span
              className="font-serif italic text-2xl md:text-4xl px-8"
              style={{ color: "#FBF6F3" }}
            >
              {w}
            </span>
            <span
              className="text-2xl md:text-3xl"
              style={{ color: "var(--accent-gold-soft)" }}
            >
              ✦
            </span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
